import React from 'react';
import sustainabilityHandIcon from 'assets/icons/icon-sustainability-hand.svg';
import PropTypes from 'prop-types';
import { SUSTAINABILITY_LEVEL } from 'constants/RAConstants/index';

export const Option = ({ handleOptionClick, level, text, isSelected }) => {
    return (
        <div role="button" onClick={handleOptionClick} className={`option ${level}${isSelected ? '--selected' : ''}`}>
            <div className="sustainability-radio-button">
                <div className="sustainability-radio-button--inner"></div>
            </div>
            <h4 className="option--title">
                {level === SUSTAINABILITY_LEVEL.INTERMEDIATE && (
                    <>
                        <img src={sustainabilityHandIcon} alt="question mark" className="sustainability-hand" />
                    </>
                )}
                {level === SUSTAINABILITY_LEVEL.ADVANCED && (
                    <>
                        <img src={sustainabilityHandIcon} alt="question mark" className="sustainability-hand" />
                        <img src={sustainabilityHandIcon} alt="question mark" className="sustainability-hand" />
                    </>
                )}
            </h4>
            <p className="option--text">{text}</p>
        </div>
    );
};

Option.propTypes = {
    handleOptionClick: PropTypes.func,
    level: PropTypes.string,
    text: PropTypes.string,
    isSelected: PropTypes.bool,
};
